import { SET_LOCALE_PREFS } from "../actions/types";

// const initialState = {
// 	countryISO2: null,
// 	currency: "USD",
// 	unitSystem: "Metric",
// 	lengthUnit: "mm",
// 	massUnit: "kg",
// 	areaUnit: "mm2",
// };

const initialState = {
	countryISO2: "IN",
	currency: "INR",
	unitSystem: "Metric", // "Metric" | "Imperial"
	lengthUnit: "mm",
	massUnit: "kg",
	areaUnit: "mm2",
};

export const localeMetrics = function (state = initialState, action: any) {
	switch (action.type) {
		case SET_LOCALE_PREFS:
			return { ...state, ...action.payload };
		default:
			return state;
	}
};
